import React, { useState } from 'react';
import { Button, Modal } from 'legion-ui';

const ModalExample = () => {
  const [isActive, setIsActive] = useState(false);
  const modalFooter = () => (
    <div style={{ display: 'flex', justifyContent: 'right' }}>
      <Button variant="soft" css={{ marginRight: '12px' }}>
        Cancel
      </Button>
      <Button>Confirm</Button>
    </div>
  );

  const toggleCustomModal = () => setIsActive(!isActive);
  const closeModal = () => setIsActive(false);

  return (
    <div>
      <Button onClick={toggleCustomModal} style={{ marginBottom: '12px' }}>
        Basic Modal
      </Button>
      <Modal
        isActive={isActive}
        modalId="legion-modal"
        iconName="Anchor"
        title="Modal Title"
        footer={modalFooter()}
        onClose={closeModal}
      >
        Pass all the necessary components as modal content here. {isActive}
      </Modal>
    </div>
  );
};

export default ModalExample;
